// extracted by mini-css-extract-plugin
export default {"wrapper":"NoData_wrapper__PmB9K"};